export default __webpack_public_path__ + "static/media/bullsheet_for_etoro.89ef5581.png";